import type { CoreQuestionResource } from '@dmp/qqms/data-access';
import type { StoreState } from '../../state-types';

export const getCoreQuestionList = (
    state: StoreState
): CoreQuestionResource[] => Object.values(state.coreQuestions);
